<script>
    import {KEY_CODE} from "../../../constants/keycodes";

    /**
     * td 에서 input 에 대한 이벤트 처리또한 같이 합니다.
     */
    export default {
        name: "FormTableComponentBaseKeyHelper",
        props: {
        },
        data() {
            return {
            }
        },
        methods: {
            /**
             * td 에 대한
             */
            initElement(el) {
                this.registerTdEventListener(el);
                const on = this.createEventHandlerObject(el);
                this.$emit("on", on);
            },

            /**
             * Td 에 대한 이벤트 리스너를 등록합니다.
             */
            registerTdEventListener(el) {
                el.addEventListener("keydown", this.onKeydownTd);
            },

            /**
             * Td 에 대한 이벤트 핸들러 객체를 생성하여 반환합니다.
             */
            createEventHandlerObject(el) {
                return {
                    keydown: (e) => {
                        // ESC 입력시 TD 에 포커싱합니다.
                        if (KEY_CODE.ESC === e.keyCode) {
                            el.focus();
                        }
                    },
                    triggerClick: (e) => {
                        el.focus();
                    },
                }
            },

            /**
             * TD의 KEYDOWN 이벤트에 대한 핸들러입니다.
             */
            onKeydownTd(e) {
                e.stopPropagation();
                this.$emit('keydown:td', e);
            },
        },
    }
</script>